// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-3TdVo";
var _4 = "form_error-3Eo9a";
var _5 = "root-2Lz7J";
var _6 = "insuranceUpsaleModal__root-3Hsc9";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "form_error", _5 as "root", _6 as "insuranceUpsaleModal__root" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "form_error": _4, "root": _5, "insuranceUpsaleModal__root": _6 }
